<template>
  <div>
    <div class="card accordion accordion-flush mt-3" id="accordionFlushExample">
      <!-- ITEM 1 del accordion -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingOne">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
            <span class="titleWizard">
              <span class="circled-number me-2" style="zoom: 1">4</span> * Modo
              avanzado: Trasvases, Caudal Ecológico, Aportaciones, Reajustes y Evaporaciones
            </span>
          </button>
        </h2>


        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne">



          <div class="accordion-body p-4">
            <!------------- INIT CONTENT DLE ACCORDION ---------------->
            <!-- PESTAÑAS -->
            <!-- Nuevo desplegable para Tipo de Año -->

            <div class="card">
              <div class="card-body h-100 p-0">
                <div class="d-flex align-items-start">
                  <div class="flex-grow-1">
                    <!-- INICIO -->
                    <ul class="nav nav-tabs nav-fill w-100">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'volTrasvases' }" id="volTrasvases"
                          data-bs-toggle="tab" href="#ssvolTrasvases" role="tab" aria-controls="volTrasvases"
                          aria-selected="true" @click="setActiveTab('volTrasvases')">
                          <i class="fa-solid fa-bridge-water"></i> Trasvases
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'volCaudalEcologico' }"
                          id="volCaudalEcologico" data-bs-toggle="tab" href="#ssvolCaudalEcologico" role="tab"
                          aria-controls="volCaudalEcologico" aria-selected="true"
                          @click="setActiveTab('volCaudalEcologico')">
                          <i class="fa-solid fa-seedling"></i> Caudal Ecológico
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'volAportaciones' }" id="volAportaciones"
                          data-bs-toggle="tab" href="#ssvolAportaciones" role="tab" aria-controls="volAportaciones"
                          aria-selected="true" @click="setActiveTab('volAportaciones')">
                          <i class="fa-solid fa-cloud-showers-water"></i> Aportaciones
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'volReajustes' }" id="volReajustes"
                          data-bs-toggle="tab" href="#ssvolReajustes" role="tab" aria-controls="volReajustes"
                          aria-selected="true" @click="setActiveTab('volReajustes')">
                          <i class="fa-solid fa-gear"></i> Reajustes
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'volEvaporaciones' }" id="volEvaporaciones"
                          data-bs-toggle="tab" href="#ssvolEvaporaciones" role="tab" aria-controls="volEvaporaciones"
                          aria-selected="true" @click="setActiveTab('volEvaporaciones')">
                          <i class="fa-solid fa-smog"></i> Evaporaciones
                        </a>
                      </li>
                    </ul>
                  </div>

                </div>

              </div>
            </div>
            <div class="col-12 col-sm-3 ms-5" style="margin-top: 30px;" v-if="!reusePlan">
              <div v-if="['volAportaciones', 'volEvaporaciones'].includes(activeTab)">
                <Select v-model="selectedYearType" id="yearTypeSelector" icon="fas fa-water" label="* Tipo de Año"
                  :options="yearTypeOptions" valKey="key" textKey="name" @change="updateYearType"
                  :disabled="viewMode == true" />
              </div>
              <div v-if="['volCaudalEcologico'].includes(activeTab)">
                <Select v-model="selectedYearTypeCaudalEco" id="yearTypeSelector2" icon="fas fa-water"
                  label="* Tipo de Año" :options="caudalEcologico" valKey="key" textKey="name" @change="updateYearType"
                  :disabled="viewMode == true" />
              </div>

            </div>
            <!-- PESTAÑAS -->
            <!-- TABS -->

            <div class="row mt-0 ms-1 me-1">
              <div class="tab-content p-0" id="myTabContent">
                <!-- TAB Volumen Reajustes -->
                <div class="tab-pane fade show" id="ssvolReajustes" role="tabpanel"
                  aria-labelledby="ssvolReajustes-tab">
                  <!-- h6 class="text-center mt-2 tableTitle">{{ reajustesTitle }}</h6> -->
                  <DataTable ref="volReajustesTable" globalID="volReajustesTable" :dataSet="localReajustes"
                    :isEditable="true" @updateValues="updateReajustes" :interruptor="interruptor" />
                </div>

                <!-- TAB Volumen Caudal Ecológico -->
                <div class="tab-pane fade show" id="ssvolCaudalEcologico" role="tabpanel"
                  aria-labelledby="ssvolCaudalEcologico-tab">
                  <!-- <h6 class="text-center mt-2 tableTitle">{{ trasvasesTitle }}</h6> -->
                  <DataTable ref="volCaudalEcologicoTable" globalID="volCaudalEcologicoTable"
                    :dataSet="localCaudalEcologico" :isEditable="true" @updateValues="updateCaudalEcologico"
                    :tipoAño="this.selectedYearType" @resetSelect="resetSelect" :interruptor="interruptor" />
                </div>
                <!-- TAB Volumen Trasvases -->
                <div class="tab-pane fade show active" id="ssvolTrasvases" role="tabpanel"
                  aria-labelledby="ssvolTrasvases-tab">
                  <!-- h6 class="text-center mt-2 tableTitle">{{ reajustesTitle }}</h6> -->
                  <DataTable ref="volTrasvasesTable" globalID="volTrasvasesTable" :dataSet="localTrasvases"
                    :isEditable="true" @updateValues="updateTrasvases" :interruptor="interruptor" />
                </div>

                <!-- TAB Volumen Aportaciones -->
                <div class="tab-pane fade show" id="ssvolAportaciones" role="tabpanel"
                  aria-labelledby="ssvolAportaciones-tab">
                  <!-- <h6 class="text-center mt-2 tableTitle">{{ trasvasesTitle }}</h6> -->
                  <DataTable ref="volAportacionesTable" globalID="volAportacionesTable" :dataSet="localAportaciones"
                    :isEditable="true" @updateValues="updateAportaciones" :tipoAño="this.selectedYearType"
                    @resetSelect="resetSelect" :interruptor="interruptor" />
                </div>
                <!-- TAB Volumen Evaporaciones -->
                <div class="tab-pane fade show" id="ssvolEvaporaciones" role="tabpanel"
                  aria-labelledby="ssvolEvaporaciones-tab">
                  <!-- <h6 class="text-center mt-2 tableTitle">{{ EvaporacionesTitle }}</h6> -->
                  <DataTable ref="volEvaporacionesTable" globalID="volEvaporacionesTable" :dataSet="localEvaporaciones"
                    :isEditable="true" @updateValues="updateEvaporaciones" :tipoAño="this.selectedYearType"
                    @resetSelect="resetSelect" :interruptor="interruptor" />
                </div>
              </div>
            </div>
            <!-- TABS -->
            <!------------- END CONTENT DLE ACCORDION ---------------->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import DataTable from "./../DataTable";
import Select from "@/components/commons/Select";
import UploadButton from "@/components/commons/UploadButton";
import PrevisionService from "@/services/PrevisionService";
import PlannerService from "@/services/PlannerService";

const CUSTOM_CAUDAL = {
  "15/03": { Aracena: 0.376, Zufre: 0.389, Minilla: 0.518, Gergal: 0.259, Cala: 0.285, Melonares: 0.181 },
  "01/04": { Aracena: 0.400, Zufre: 0.415, Minilla: 0.553, Gergal: 0.276, Cala: 0.304, Melonares: 0.194 },
  "15/04": { Aracena: 0.376, Zufre: 0.389, Minilla: 0.518, Gergal: 0.259, Cala: 0.285, Melonares: 0.181 },
  "01/05": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "15/05": { Aracena: 0.194, Zufre: 0.194, Minilla: 0.263, Gergal: 0.276, Cala: 0.152, Melonares: 0.194 },
  "01/06": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "15/06": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "01/07": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "15/07": { Aracena: 0.194, Zufre: 0.194, Minilla: 0.263, Gergal: 0.276, Cala: 0.152, Melonares: 0.194 },
  "01/08": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "15/08": { Aracena: 0.194, Zufre: 0.194, Minilla: 0.263, Gergal: 0.276, Cala: 0.152, Melonares: 0.194 },
  "01/09": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "15/09": { Aracena: 0.181, Zufre: 0.181, Minilla: 0.246, Gergal: 0.259, Cala: 0.143, Melonares: 0.181 },
  "01/10": { Aracena: 0.194, Zufre: 0.207, Minilla: 0.272, Gergal: 0.259, Cala: 0.156, Melonares: 0.181 },
  "15/10": { Aracena: 0.207, Zufre: 0.221, Minilla: 0.290, Gergal: 0.276, Cala: 0.166, Melonares: 0.194 },
  "01/11": { Aracena: 0.194, Zufre: 0.207, Minilla: 0.272, Gergal: 0.259, Cala: 0.156, Melonares: 0.181 },
  "15/11": { Aracena: 0.194, Zufre: 0.207, Minilla: 0.272, Gergal: 0.259, Cala: 0.156, Melonares: 0.181 },
  "01/12": { Aracena: 0.376, Zufre: 0.389, Minilla: 0.518, Gergal: 0.259, Cala: 0.285, Melonares: 0.181 },
  "15/12": { Aracena: 0.401, Zufre: 0.415, Minilla: 0.553, Gergal: 0.276, Cala: 0.304, Melonares: 0.194 }
};

const CUSTOM_APORTACIONES = {
  "15/03": { Aracena: 1.650, Zufre: 2.200,  Minilla: 0.600,  Gergal: 0.700,  Cala: 1.550, Melonares: 1.550 },
  "01/04": { Aracena: 1.400, Zufre: 1.900,  Minilla: 0.200,  Gergal: 0.200,  Cala: 0.800, Melonares: 1.200 },
  "15/04": { Aracena: 1.400, Zufre: 1.900,  Minilla: 0.200,  Gergal: 0.200,  Cala: 0.800, Melonares: 1.200 },
  "01/05": { Aracena: 0.750, Zufre: 1.000,  Minilla: 0.100,  Gergal: 0.100,  Cala: 0.300, Melonares: 0.800 },
  "15/05": { Aracena: 0.750, Zufre: 1.000,  Minilla: 0.100,  Gergal: 0.100,  Cala: 0.300, Melonares: 0.800 },
  "01/06": { Aracena: 0.650, Zufre: 0.900,  Minilla: 0.100,  Gergal: 0.050,  Cala: 0.250, Melonares: 0.700 },
  "15/06": { Aracena: 0.650, Zufre: 0.900,  Minilla: 0.100,  Gergal: 0.050,  Cala: 0.250, Melonares: 0.700 },
  "01/11": { Aracena: 3.000, Zufre: 3.000,  Minilla: 1.000,  Gergal: 1.000,  Cala: 1.000, Melonares: 3.000 },
  "15/11": { Aracena: 3.000, Zufre: 3.000,  Minilla: 1.500,  Gergal: 1.500,  Cala: 2.000, Melonares: 3.000 },
  "01/12": { Aracena: 5.000, Zufre: 5.000,  Minilla: 2.000,  Gergal: 2.000,  Cala: 2.000, Melonares: 5.000 },
  "15/12": { Aracena: 5.000, Zufre: 5.000,  Minilla: 2.000,  Gergal: 2.000,  Cala: 2.000, Melonares: 5.000 }
};

export default {
  data() {
    return {
      localTrasvases: {},
      localReajustes: {},
      localCaudalEcologico: {},
      localAportaciones: {},
      localEvaporaciones: {},
      selectedYearType: 'húmedo',
      yearTypeOptions: [
        { key: 'normal', name: 'Normal' },
        { key: 'seco', name: 'Seco' }
      ],
      activeTab: 'volTrasvases',
      caudalEcologico: null,
      selectedYearTypeCaudalEco: 'seco'
    };
  },
  props: {
    reusePlan: {
      type: Boolean,
      default: false,
    },
    interruptor: {
      type: Boolean,
      default: false,
    },
    datosVigentes: {
      type: Array,
      default: []
    },
    anioVigente: {
      type: String,
      default: ' '
    },
  },
  components: {
    Select,
    UploadButton,
    DataTable,
  },
  watch: {
    v_selectedYear: async function (newVal, oldVal) {
      if (newVal != this.anioVigente)
        await this.getTransfersAndReadjustments();
    },

    reusePlan: async function (newVal, oldVal) {
      // if (newVal == true) {
      //   await this.populateData(this.v_reusePlan);
      // }
    },

    v_selectedYearType: function (newVal, oldVal) {
      if (newVal != null && this.viewMode == true) {
        this.selectedYearType = newVal;
        // Llama a updateDataSet cuando cambie el tipo de año
        //this.updateDataSet(newVal);
      }
    },
    datosVigentes: function (newVal, oldVal) {
      if (newVal && this.reusePlan) {
        this.selectedYearType = ' ';
        this.populateData(newVal);
      }
    },
    anioVigente: async function (newVal, oldVal) {
      if (newVal && this.reusePlan) {
        this.populateData(this.datosVigentes);
      }
    },
    selectedYearType: function (newVal, oldVal) {
      //if (this.reusePlan)
        this.getTransfersAndReadjustments();
    },
    selectedYearTypeCaudalEco: function (newVal, oldVal) {
      //if (this.reusePlan)
        this.getTransfersAndReadjustments();
    },
  },

  computed: {
    ...mapState("planner", [
      "v_selectedYear",
      "v_transfers",
      "v_readjustments",
      "v_caudal",
      "v_aportations",
      "v_evaporatios",
      "v_reusePlan",
      "v_selectedYearType"
    ]),
    reajustesTitle: function (val) {
      let titulo = "REAJUSTES EN " + this.v_selectedYear;
      return titulo;
    },
    trasvasesTitle: function (val) {
      let titulo = "TRASVASES EN " + this.v_selectedYear;
      return titulo;
    },
    caudalEcologicoTitle: function (val) {
      let titulo = "CAUDAL ECOLOGICO EN " + this.v_selectedYear;
      return titulo;
    },
    aportacionesTitle: function (val) {
      let titulo = "APORTACIONES EN " + this.v_selectedYear;
      return titulo;
    },
    evaporacionesTitle: function (val) {
      let titulo = "Evaporaciones EN " + this.v_selectedYear;
      return titulo;
    },
  },
  methods: {
    ...mapActions("planner", ["v_updTransfers", "v_updReadjustments", "v_updCaudal", "v_updAportations", "v_updEvaporations", "v_updSelectedYearType", "v_dataSet", "v_transfers"]),
    updateTrasvases(newDataSet) {
      this.v_updTransfers(newDataSet);
      //console.log("Trasvases actualizados", this.v_transfers);
    },
    resetSelect() {
      this.selectedYearType = 'normal';
    },

    updateReajustes(newDataSet) {
      this.v_updReadjustments(newDataSet);
    },
    updateCaudalEcologico(newDataSet) {
      this.v_updCaudal(newDataSet);
    },
    updateEvaporaciones(newDataSet) {
      this.v_updEvaporations(newDataSet);
    },
    updateAportaciones(newDataSet) {
      this.v_updAportations(newDataSet);
    },
    async updateYearType() {
      const selectedOption = this.yearTypeOptions.find(option => option.key === this.selectedYearType);
      this.v_updSelectedYearType(selectedOption);
      this.selectedYearDesdeFecha = selectedOption && selectedOption.desde_fecha;
      //console.log("Valor seleccionado para YearType:", this.selectedYearType);
      //console.log("Fecha asociada desde_fecha:", selectedOption?.desde_fecha); 

    },
    setActiveTab(tabId) {
      // if(tabId == 'volCaudalEcologico' && !this.reusePlan){
      //   this.selectedYearType = 'seco';
      // }
      this.activeTab = tabId;
    },



    async getTransfersAndReadjustments() {
      //console.log("Año seleccionado:", this.datosVigentes.length>0 ? this.datosVigentes : 0);
      if (this.datosVigentes && this.datosVigentes.length > 0 && this.reusePlan) {
        this.populateData(this.datosVigentes);
      }
      else {
        const response = await PrevisionService.getTranfersAndReadjustmentsInitial(
          this.v_selectedYear
        );
        if (response.data) {
          this.populateData(response.data);
        } else {
          console.error("Error al recuperar los datos del plan inicial");
        }
      }
      // if (this.anioVigente !== this.v_selectedYear && this.anioVigente || !this.reusePlan) {
      //   const param = this.$route.query.reuseplan;

      //   const response = await PrevisionService.getTranfersAndReadjustmentsInitial(
      //     this.v_selectedYear
      //   );


      //   if (response.data) {
      //     this.populateData(response.data);
      //   } else {
      //     console.error("Error al recuperar los datos del plan inicial");
      //   }
      // } else {
      //   if(this.reusePlan){
      //     this.populateData(this.datosVigentes);
      //   }
      // }
    },

    populateData(dataRaw) {
      //Reconvertimos a los arrays necesarios
      let dataSet = {
        planReajustes: {
          columnas: [{ colspan: "2", label: "", subLabels: ["Fecha", "Dias"] }],
          filas: [],
        },
        planTrasvases: {
          columnas: [{ colspan: "2", label: "", subLabels: ["Fecha", "Dias"] }],
          filas: [],
        },
        planCaudalEco: {
          columnas: [{ colspan: "2", label: "", subLabels: ["Fecha", "Dias"] }],
          filas: [],
        },
        planAportaciones: {
          columnas: [{ colspan: "2", label: "", subLabels: ["Fecha", "Dias"] }],
          filas: [],
        },
        planEvaporaciones: {
          columnas: [{ colspan: "2", label: "", subLabels: ["Fecha", "Dias"] }],
          filas: [],
        },
      };

      /** Recorremos el array y metemos las columnas evitadno qeu se dupliquen **/
      /************************************************************************ */
      for (let item of dataRaw) {

        // Meter cabeceras en planReajustes y planTrasvases
        if (item) {
          const itemExists = dataSet.planTrasvases.columnas.some(
            (itemloc) => itemloc.label === item.Nombre_Embalse
          );
          if (!itemExists) {
            dataSet.planTrasvases.columnas.push({
              colspan: "1",
              label: item.Nombre_Embalse,
              subLabels: ["hm3"],
            });
            dataSet.planReajustes.columnas.push({
              colspan: "1",
              label: item.Nombre_Embalse,
              subLabels: ["hm3"],
            });
            dataSet.planCaudalEco.columnas.push({
              colspan: "1",
              label: item.Nombre_Embalse,
              subLabels: ["m3/s"],
            });
            dataSet.planAportaciones.columnas.push({
              colspan: "1",
              label: item.Nombre_Embalse,
              subLabels: ["hm3"],
            });
            dataSet.planEvaporaciones.columnas.push({
              colspan: "1",
              label: item.Nombre_Embalse,
              subLabels: ["hm3"],
            });

          }
        }

        //Meter fechas en todos los casos

        const itemExists = dataSet.planTrasvases.filas.some(
          (itemloc) => itemloc.fecha === item.Fecha
        );
        if (!itemExists && item.Nombre_Embalse != 'CriterioOptimizacion') {
          dataSet.planReajustes.filas.push({
            fecha: item.Fecha,
            masasAgua: [],
            ndias: item.Dias,
          });
          dataSet.planTrasvases.filas.push({
            fecha: item.Fecha,
            masasAgua: [],
            ndias: item.Dias,
          });
          dataSet.planCaudalEco.filas.push({
            fecha: item.Fecha,
            masasAgua: [],
            ndias: item.Dias,
          });
          dataSet.planAportaciones.filas.push({
            fecha: item.Fecha,
            masasAgua: [],
            ndias: item.Dias,
          });
          dataSet.planEvaporaciones.filas.push({
            fecha: item.Fecha,
            masasAgua: [],
            ndias: item.Dias,
          });
        }
      }

      /** Recorremos el array extrayendo los datos y rellenando los items inmediatos **/
      /****************************************************************************** */
      for (let item of dataRaw) {
        if (item.Nombre_Embalse != 'CriterioOptimizacion' && item.Nombre_Embalse != "Días" && item.Nombre_Embalse != null) {
          // Encuentra el índice de la fila en el plan de trasvases que coincide con la fecha
          let index = dataSet.planTrasvases.filas.findIndex(
            (item2) => item2.fecha === item.Fecha
          );

          if (index != -1) {
            // Verifica si el embalse existe en las columnas del plan de trasvases
            const itemExists = dataSet.planTrasvases.columnas.some(
              (itemloc) => itemloc.label === item.Nombre_Embalse
            );

            if (itemExists) {
              // Obtén el tipo de año seleccionado
              const selectedYearType = this.selectedYearType;

              // Función para calcular valores basados en ndias y factor de conversión
              const calculateValue = (value, ndias) => {
                //console.log(value, ndias,"valor y dias");
                //const conversionFactor = 1 / ((ndias || 1) * 0.0864);
                //console.log((value * 11.5740)/ndias,"valor calculado");
                return value ? ((value * 11.5740) / ndias).toFixed(2) : 0;
              };

              //console.log("dataset", dataSet);

              // Lógica para caudal ecológico
              const ndias2 = dataSet.planCaudalEco.filas[index].ndias || 1;
              let caudalValueM3s = 0;

              if (this.selectedYearTypeCaudalEco === "normal") {
                caudalValueM3s = item.CaudalEcologicoNormal
                  ? calculateValue(item.CaudalEcologicoNormal, ndias2)
                  : 0;
              } else if (this.selectedYearTypeCaudalEco === "seco" && !this.reusePlan) {
                //console.log("Sequia", item.CaudalEcologicoSequia, ndias2);
                caudalValueM3s = item.CaudalEcologicoSequia
                  ? calculateValue(item.CaudalEcologicoSequia, ndias2)
                  : 0;
              } else if (this.reusePlan) {
                caudalValueM3s = item.CaudalEcologico
                  ? item.CaudalEcologico
                  : 0;
              }

              if (!this.reusePlan && CUSTOM_CAUDAL[item.Fecha] && CUSTOM_CAUDAL[item.Fecha][item.Nombre_Embalse] !== undefined) {
                caudalValueM3s = CUSTOM_CAUDAL[item.Fecha][item.Nombre_Embalse];
              }

              if (caudalValueM3s !== null) {
                dataSet.planCaudalEco.filas[index].masasAgua.push({
                  extraido: { value: caudalValueM3s },
                  label: item.Nombre_Embalse,
                });
              }

              // Lógica para trasvases
              if (this.reusePlan) {
                dataSet.planTrasvases.filas[index].masasAgua.push({
                  extraido: { value: item.Trasvase ? item.Trasvase : "0" },
                  label: item.Nombre_Embalse,
                });

                dataSet.planReajustes.filas[index].masasAgua.push({
                  extraido: { value: item.Reajuste ? item.Reajuste : "0" },
                  label: item.Nombre_Embalse,
                });
                dataSet.planAportaciones.filas[index].masasAgua.push({
                  extraido: { value: item.AportacionLluvia ? item.AportacionLluvia : "0" },
                  label: item.Nombre_Embalse,
                });

                dataSet.planEvaporaciones.filas[index].masasAgua.push({
                  extraido: { value: item.Evaporacion ? item.Evaporacion : "0" },
                  label: item.Nombre_Embalse,
                });

              } else {

                dataSet.planTrasvases.filas[index].masasAgua.push({
                  extraido: { value: item.Trasvases ? item.Trasvases : "0" },
                  label: item.Nombre_Embalse,
                });

                dataSet.planReajustes.filas[index].masasAgua.push({
                  extraido: { value: item.Reajustes ? item.Reajustes : "0" },
                  label: item.Nombre_Embalse,
                });




                let valorAportacion = 0; // Por defecto número 0 para no pintar guiones

                if (!this.reusePlan && CUSTOM_APORTACIONES[item.Fecha] && CUSTOM_APORTACIONES[item.Fecha][item.Nombre_Embalse] !== undefined) {
                    valorAportacion = CUSTOM_APORTACIONES[item.Fecha][item.Nombre_Embalse];
                } else {
                    let valorBD = null;
                    if (selectedYearType === "normal") valorBD = item.AportacionNormal;
                    else if (selectedYearType === "seco") valorBD = item.AportacionSeco;
                    else if (selectedYearType === "húmedo") valorBD = item.AportacionHumedo;

                    // Si la BBDD tiene un valor real, lo usamos. Rechazamos nulos, vacíos y guiones para que quede en 0
                    if (valorBD !== null && valorBD !== undefined && valorBD !== "" && valorBD !== "0" && valorBD !== "-") {
                        valorAportacion = valorBD;
                    }

                    // Restaurar regla estricta de la usuaria: desde julio hasta octubre forzar ceros
                    const fechasVerano = ["01/07", "15/07", "01/08", "15/08", "01/09", "15/09", "01/10", "15/10"];
                    if (fechasVerano.includes(item.Fecha)) {
                        valorAportacion = 0;
                    }
                }

                dataSet.planAportaciones.filas[index].masasAgua.push({
                    extraido: { value: valorAportacion },
                    label: item.Nombre_Embalse,
                });
                //console.log("apf", aportacionesValueM3s)






                if (selectedYearType === "normal") {
                  dataSet.planEvaporaciones.filas[index].masasAgua.push({
                    extraido: { value: item.EvaporacionNormal ? item.EvaporacionNormal : "0" },
                    label: item.Nombre_Embalse,
                  });
                } else if (selectedYearType === "seco") {
                  dataSet.planEvaporaciones.filas[index].masasAgua.push({
                    extraido: { value: item.EvaporacionSeco ? item.EvaporacionSeco : "0" },
                    label: item.Nombre_Embalse,
                  });
                } else if (selectedYearType === "húmedo") {
                  dataSet.planEvaporaciones.filas[index].masasAgua.push({
                    extraido: { value: item.EvaporacionHumedo ? item.EvaporacionHumedo : "0" },
                    label: item.Nombre_Embalse,
                  });
                }
              }

            }
          }
        }

      }



      let list2 = [
        "",
        "Aracena",
        "Zufre",
        "Minilla",
        "Gergal",
        "Cala",
        "Melonares",
      ];

      // Ordenar Columnas planTrasvases y planReajustes
      //let auxArray = new Array(dataSet.planTrasvases.columnas);
      // Crear un array auxiliar ordenado basado en list2
      // Crear un array auxiliar basado en list2
      // Almacenamos las columnas sin sobrescribirlas
      // Crear arrays auxiliares para almacenar las columnas en el orden deseado
      let auxTrasvases = [];
      let auxReajustes = [];
      let auxCaudalEco = [];
      let auxAportaciones = [];
      let auxEvaporaciones = [];

      // Recorrer list2 y reorganizar las columnas según este orden
      for (let i = 0; i < list2.length; i++) {
        // Encontrar el índice de la columna que coincide con la etiqueta de list2
        const index = dataSet.planTrasvases.columnas.findIndex(
          (item) => item.label === list2[i]
        );

        if (index !== -1) {
          // Agregar las columnas correspondientes a los arrays auxiliares
          auxTrasvases.push(dataSet.planTrasvases.columnas[index]);
          auxCaudalEco.push(dataSet.planCaudalEco.columnas[index]);
          auxAportaciones.push(dataSet.planAportaciones.columnas[index]);
          auxReajustes.push(dataSet.planReajustes.columnas[index]);
          auxEvaporaciones.push(dataSet.planEvaporaciones.columnas[index]);
        }
      }

      // Reasignar las columnas con los arrays reorganizados
      dataSet.planReajustes.columnas = auxReajustes;
      dataSet.planAportaciones.columnas = auxAportaciones;
      dataSet.planCaudalEco.columnas = auxCaudalEco;
      dataSet.planEvaporaciones.columnas = auxEvaporaciones;
      dataSet.planTrasvases.columnas = auxTrasvases;







      // Para uso local
      this.localTrasvases = dataSet.planTrasvases;
      this.localReajustes = dataSet.planReajustes;
      this.localCaudalEcologico = dataSet.planCaudalEco;
      this.localAportaciones = dataSet.planAportaciones;
      this.localEvaporaciones = dataSet.planEvaporaciones;


      if (this.localTrasvases.filas.length > 24) {
        this.localTrasvases.filas.splice(-1, 1)
      }

      if (this.localReajustes.filas.length > 24) {
        this.localReajustes.filas.splice(-1, 1)
      }

      if (this.localAportaciones.filas.length > 24) {
        this.localAportaciones.filas.splice(-1, 1)
      }

      if (this.localCaudalEcologico.filas.length > 24) {
        this.localCaudalEcologico.filas.splice(-1, 1)
      }

      if (this.localEvaporaciones.filas.length > 24) {
        this.localEvaporaciones.filas.splice(-1, 1)
      }

      // Per defecto rellenamos el almacen de vuex
      this.v_updTransfers(dataSet.planTrasvases);
      this.v_updReadjustments(dataSet.planReajustes);
      this.v_updCaudal(dataSet.planCaudalEco);
      this.v_updAportations(dataSet.planAportaciones);
      this.v_updEvaporations(dataSet.planEvaporaciones);


    },

  },
  async mounted() {
    /* Seleccionar elemento por defecto al cargar */
    let response_01 = await PlannerService.getFormsOptions();
    let response_02 = await PrevisionService.getYearsPrevActual();

    await this.getTransfersAndReadjustments();

    if (response_02.data) {
      // Populate selects
      this.yearsList = response_02.data;
      //Con este pop quitamos el ultimo año del select para que el usuario no pueda hacer planes sobre él, ya que al no
      //haber planes previos, el algoritmo no funcionará.
      this.yearsList.pop();

      // En caso de que el plan sea nuevo
      ////////////////////////////////////
      if (this.reusePlan != true || this.v_selectedYear == null) {
        // Select defaults
        this.selectedYear = await this.yearsList[0].name;
        // Lo guardamos reactivamente para que se popule por todos sitios




      } else {
        this.selectedYear = await this.v_selectedYear;

      }
    } else {
      console.log(
        "No se pudo obtener datos desde el backend. Contacte con el desarrollador"
      );
    }

    if (response_01.data) {
      // Populate selects
      this.criteriaList = response_01.data.criteria;
      this.startDateList = response_01.data.startDates;
      this.yearTypeOptions = response_01.data.type;
      this.caudalEcologico = response_01.data.type.slice(0, 2);

      // console.log("Contenido de response_01.data.type:", response_01.data.type); 
      //console.log("Contenido de response_01.data.type fecha:", response_01.data.type.key); 
      // En caso de que el plan sea nuevo
      ////////////////////////////////////
      if (this.reusePlan != true || this.v_selectedCriteria == null) {
        // Select defaults
        this.selectedCriteria = await this.criteriaList[0].key;
        this.selectedStartDate = await this.startDateList[0].key;
        //this.selectedYearType = {desde_fecha: this.yearTypeOptions[0].desde_fecha,type:this.yearTypeOptions[0].key};
        this.selectedYearType = "húmedo";
        // console.log("Valor:", this.yearTypeOptions[1].key);
        // console.log("Valor fecha:", this.yearTypeOptions[0].desde_fecha);
        // console.log("Valor detipo y fecha",this.selectedYearType )
        this.v_updSelectedYearType(this.yearTypeOptions[1]);
      } else {
        this.selectedCriteria = await this.v_selectedCriteria;
      }
    } else {
      console.log(
        "No se pudo obtener datos desde el backend. Contacte con el desarrollador"
      );
    }
  },

};




</script>

<style scoped>
/* Sobreescribir configuraciones por defecto */
.card {
  max-width: 100%;
}

.nav-tabs .nav-link {
  color: gray;
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link:hover {
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link.active {
  color: #000000;
  border: 0;
  border-radius: 1;
  border-bottom: 2px solid #4ca1ef;
  background-color: #cde9ff;
}

.nav-item:hover {
  background-color: #f0f7fc;
  transition: background-color 0.5s ease;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
}
</style>